import logo from './apex-hero-medium-logo-light.svg';
import './App.css';

function App() {
  return (
    <div className="container-fluid text-center bg-primary mh-100 g-0">
      <header className="header row g-0">
        <img src={logo} className="align-middle w-50 m-auto" alt="Apex Logo" />
      </header>
    </div>
  );
}

export default App;
